/* eslint-disable react/no-unescaped-entities */
import React from 'react';

function Release20250513() {
  return (
    <section className="flex flex-col gap-4 border-b">
      <h2 className="font-gothammedium text-neutral-700">Enrichment_26/S7</h2>
      <p className="-mt-4">13th May 2025</p>

      <h4>Notice:</h4>
      <h5>Releases Covered:</h5>
      <ul className="-mt-4">
        <li>Enrichment_25/S27_E02</li>
        <li>Enrichment_25/S26_E01</li>
      </ul>

      <h3 className="font-gothammedium text-neutral-700">
        New Functionality
      </h3>

      {/* <h4>User Management</h4> */}

      <ul className="-mt-4">
        <li>(Indexing) - Allow users to run All product delete manually in the UI</li>
        <li>(User Management) - Enable / Disable Groups</li>
        <li>(User Management) - Change the User and Group Icons</li>
        <li>(User Management) - When a new user is created in Prism, include the added and added user to SAML email</li>
        <li>(User Management) - Add adder and added user to the saml email</li>
        <li>(B2B API) - Create new endpoints for PLU(s) - Tax Data</li>
        <li>(B2B API) - Implement Shared Token for API Authentication</li>
        <li>(Bulk Operations) - Admins and Group Admins : Delete Attribute Values</li>
      </ul>

      <h3 className="font-gothammedium text-neutral-700">Fixes & Improvements</h3>

      <ul className="-mt-4">
        <li>(Bulk Operations) - PLU is accepting many characters and after submitting seeing exception in Failed Tab as Failure Reason</li>
        <li>(Bulk Operations) - Approve / Enable Stock - Refresh search results after a bulk has finished</li>
        <li>Approve / Enable Stock - Refresh search results after a bulk has finished</li>
        <li>Getting white screen when updating flag attributes</li>
        <li>(User Management) - User Latest Login is not updating</li>
        <li>(User Management) - Group Updated date is not updating in group tab</li>
        <li>(User Management) - Stability Fixes</li>
        <li>(Attributes Def) - Search by Attributes for Outdoors not returning the correct count</li>
        <li>(PDP) - General Tab Errors and Loading issue</li>
        <li>(Attributes Def) - When selected ID ! Outdoor Group, hide from site dropdown list</li>
        <li>Returns Portal Flag Reverting to True in PRISM.</li>
      </ul>
    </section>
  );
}

export default Release20250513;
